export const errorMessage = {
  ErrorOccured: 'ErrorOccured',
  Unauthorized: 'Unauthorized',
  UnauthorizedAccess: 'unauthorized_access',
  UserAlreadyLogin: 'UserAlreadyLogin',
  AccessedByOtherUser: 'AccessedByOtherUser',
  SessionExpired: 'SessionExpired',
  InvalidUserIdOrPassword: 'InvalidUserIdOrPassword',
  UserEmailNotFound: 'UserEmailNotFound',
  YourAccountInactive: 'YourAccountInactive',
  SomethingWentWrong: 'SomethingWentWrong',
  AlreadyExists: 'AlreadyExists',
  ProcessAlreadyExists: 'ProcessAlreadyExists',
  ProcessInUse: 'ProcessInUse',
};
